import { render, staticRenderFns } from "./ObjektiCard2Tab-1-Osnovno.vue?vue&type=template&id=f85a49b6&scoped=true&"
import script from "./ObjektiCard2Tab-1-Osnovno.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-1-Osnovno.vue?vue&type=script&lang=ts&"
import style0 from "./ObjektiCard2Tab-1-Osnovno.vue?vue&type=style&index=0&id=f85a49b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a49b6",
  null
  
)

export default component.exports